window.TV2 = window.TV2 || {};

window.TV2.initReservation = (loginEnabled) => {
  const button = document.getElementById('reservationButton');
  const buttonWrapper = document.querySelector('.cookie__wrapper');
  const cookie = TV2.getCookieValue('_pbjs_id_optout');

  if (cookie === '1') {
    button.classList.remove('push-subscribe-button--on');
  }

  if (loginEnabled) {
    window.TV2.getLoggedInUser()
      .then((user) => {
        if (user) {
          buttonWrapper.innerHTML = `Du er logget inn som <span class="bold" data-lab-bold_desktop="bold">${user.firstname} ${user.lastname}</span>, og du kan endre innstillingene dine på <a href="https://id.tv2.no/konto/personvern">din side</a>.`;
        }
      })
      .catch((err) => console.error(err));
  }
};

window.TV2.toggleReservation = () => {
  const button = document.getElementById('reservationButton');
  const cookieKey = '_pbjs_id_optout';
  const cookie = TV2.getCookieValue(cookieKey);
  const cookieValue = cookie ? cookie.split('') : [];
  const loc = window.location.host.split('.');
  const domain = `${loc[loc.length - 2]}.${loc[loc.length - 1]}`;

  if (cookieValue.length === 0) {
    cookieValue[0] = '1';

    document.cookie = `${cookieKey}=${cookieValue.join('')}; domain=${domain}; path=/; max-age=${
      60 * 60 * 24 * 365 * 10
    }`;

    button.classList.remove('push-subscribe-button--on');
  } else {
    document.cookie = `${cookieKey}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    button.classList.add('push-subscribe-button--on');
  }
};
